<!-- New password view (first-time / change-password) -->
<section class="form-group" [ngClass]="{ 'd-none': loading }">
  <article [ngClass]="theme.getThemeClass()" class="wrapper fadeInDown">
    <div id="formContent" [ngClass]="theme.getThemeClass()">
      <img
        class="logo"
        src="../assets/muirwood-studio.png"
        [ngClass]="theme.getThemeClass()"
      />
      <br />
      <h2 [ngClass]="theme.getThemeClass()" class="text-center">
        {{ "loginFNewPassword" | translate }}
      </h2>
      <p>{{ "loginFNewPasswordMessage" | translate }}</p>
      <!-- You can reset your password here.-->
      <div class="panel-body">
        <form
          name="newPassForm"
          (ngSubmit)="ctx.confirmNewPasswordClick()"
          id="register-form"
          role="form"
          autocomplete="off"
          class="form"
          method="post"
        >
          <div [ngClass]="theme.getThemeClass()" class="form-group">
            @if (ctx.cognitoService.challengeName !== 'NEW_PASSWORD_REQUIRED') {
            <div class="password-input">
              <!-- Old password -->
              <input
                type="{{ ctx.showOldPassword ? 'text' : 'password' }}"
                id="oldPassword"
                [(ngModel)]="ctx.user.password"
                class="form-control font14px"
                name="requestOldPassword"
                placeholder="{{
                  'loginFNewPasswordPlaceHolderOldPassword' | translate
                }}"
                required
                minlength="1"
                #requestPassword="ngModel"
              />
              <span (click)="ctx.togglePasswordVisibility('oldPassword')">
                <i
                  id="eyeIconOldPassword"
                  class="fa text-dark"
                  [class.fa-eye-slash]="!ctx.showOldPassword"
                  style="color: #000"
                ></i>
              </span>
            </div>
            } @else {
            <input type="hidden" [(ngModel)]="ctx.user.password" name="requestOldPassword" />
            }
            <!-- New password input -->
            <div [ngClass]="theme.getThemeClass()" class="password-input">
              <input
                type="{{ ctx.showPassword ? 'text' : 'password' }}"
                id="newPassword"
                [(ngModel)]="ctx.requestNewPassword"
                class="form-control font14px"
                name="requestNewPasswordfirst"
                placeholder="{{
                  'loginFNewPasswordPlaceHolderNewPassword' | translate
                }}"
                required
                minlength="1"
                #requestPassword="ngModel"
                (input)="ctx.validatePasswordInput(ctx.requestNewPassword, false)"
              />
              <!-- Toggle show/hide password -->
              <span (click)="ctx.togglePasswordVisibility('password')">
                <i
                  id="eyeIconPassword"
                  class="fa text-dark"
                  [class.fa-eye-slash]="!ctx.showPassword"
                  style="color: #000"
                ></i>
              </span>
            </div>

            @if (ctx.showAlertStrong) {
            <div class="colorGreen">
              {{ "loginFNewPasswordAlertStrongPassword" | translate }}
            </div>
            } @if (ctx.showAlertWeak) {
            <div class="colorRed">
              {{ "loginFNewPasswordAlertWeakPassword" | translate }}
            </div>
            }
            <div class="password-input">
              <!-- Confirm new password -->
              <input
                type="{{ ctx.showPasswordConfirmation ? 'text' : 'password' }}"
                id="newPasswordConfirmation"
                [(ngModel)]="ctx.requestNewPasswordConfirmation"
                class="form-control font14px"
                name="requestNewPasswordConfirm"
                placeholder="{{
                  'loginFNewPasswordPlaceHolderConfirmNewPassword' | translate
                }}"
                required
                minlength="1"
                #requestPasswordConf="ngModel"
              />
              <!-- Toggle show/hide password -->
              <span (click)="ctx.togglePasswordVisibility('confirmPassword')">
                <i
                  id="eyeIconConfirmPassword"
                  class="fa text-dark"
                  [class.fa-eye-slash]="!ctx.showPasswordConfirmation"
                ></i>
              </span>
            </div>
            @if (ctx.showCheckBoxTip) {
            <div class="popup" [ngClass]="theme.getThemeClass()">
              <label>{{
                "loginFNewPasswordLabelPasswordRequirements" | translate
              }}</label>
              <!-- Section IMG for password wickness -->
              <nav class="container-checkbox centered-container">
                @if (!ctx.charactersChecked) {
                <img
                  id="noChecked"
                  src="assets/iconchecked.png"
                  alt="dinamicCheckBox"
                  class="checkSymbol"
                />
                } @else {
                <img
                  id="noChecked"
                  src="assets/icochecked.png"
                  alt="dinamicCheckBox"
                  class="checkSymbol"
                />
                }
                <span>{{
                  "loginFNewPasswordPasswordRequirementsCharQtt" | translate
                }}</span>
              </nav>
              <nav
                class="centered-container container-checkbox"
                [ngClass]="theme.getThemeClass()"
              >
                @if (!ctx.lowerCaseChecked) {
                <img
                  id="noChecked"
                  src="assets/iconchecked.png"
                  alt="dinamicCheckBox"
                  class="checkSymbol"
                />
                } @else {
                <img
                  id="noChecked"
                  src="assets/icochecked.png"
                  alt="dinamicCheckBox"
                  class="checkSymbol"
                />
                }
                <span>{{
                  "loginFNewPasswordPasswordRequirementsOneLowercaseLetter"
                    | translate
                }}</span>
              </nav>
              <nav
                class="centered-container container-checkbox"
                [ngClass]="theme.getThemeClass()"
              >
                @if (!ctx.upperCaseChecked) {
                <img
                  id="noChecked"
                  src="assets/iconchecked.png"
                  alt="dinamicCheckBox"
                  class="checkSymbol"
                />
                } @else {
                <img
                  id="noChecked"
                  src="assets/icochecked.png"
                  alt="dinamicCheckBox"
                  class="checkSymbol"
                />
                }
                <span>{{
                  "loginFNewPasswordPasswordRequirementsOneUppercaseLetter"
                    | translate
                }}</span>
              </nav>
              <nav
                class="centered-container container-checkbox"
                [ngClass]="theme.getThemeClass()"
              >
                @if (!ctx.oneDigitChecked) {
                <img
                  id="noChecked"
                  src="assets/iconchecked.png"
                  alt="dinamicCheckBox"
                  class="checkSymbol"
                />
                } @else {
                <img
                  id="noChecked"
                  src="assets/icochecked.png"
                  alt="dinamicCheckBox"
                  class="checkSymbol"
                />
                }
                <span>{{
                  "loginFNewPasswordPasswordRequirementsOneDigit" | translate
                }}</span>
              </nav>
              <nav
                class="centered-container container-checkbox"
                [ngClass]="theme.getThemeClass()"
              >
                @if (!ctx.specialCharChecked) {
                <img
                  id="noChecked"
                  src="assets/iconchecked.png"
                  alt="dinamicCheckBox"
                  class="checkSymbol"
                />
                } @else {
                <img
                  id="noChecked"
                  src="assets/icochecked.png"
                  alt="dinamicCheckBox"
                  class="checkSymbol"
                />
                }
                <!-- End of section IMG for password wickness -->
                <span>{{
                  "loginFNewPasswordPasswordRequirementsOneSpecialChar"
                    | translate
                }}</span>
              </nav>
            </div>
            }
            @if (ctx.requestNewPassword !== ctx.requestNewPasswordConfirmation) {
            <div class="customalert">
              {{ "loginFNewPasswordAlertPwDontMatch" | translate }}
            </div>
            }
            <div class="recoverBtn">
              <a>
                <input
                  name="recover-return"
                  class="btn btn-lg btn-primary btn-block return-btn"
                  value="{{ 'userEditButtonLabelReturn' | translate }}"
                  type="button"
                  (click)="ctx.cancelHandler()"
                />
              </a>
              <a>
                <input
                  name="recover-submit"
                  class="btn btn-lg btn-primary btn-block submit-btn"
                  value="{{ 'loginFNewPasswordBtnConfirmNewPw' | translate }}"
                  type="submit"
                />
              </a>
            </div>
          </div>
        </form>
      </div>
    </div>
  </article>
</section>
